import React from 'react'
import { CFooter } from 'compat/coreui'

const DashFooter = () => {
  return (
    <CFooter fixed={false}>
      <div>
        <span>BirrPlug &copy; {new Date().getFullYear()} · Powered by BRDPoSChain</span>
      </div>
    </CFooter>
  )
}

export default DashFooter;
